import React from 'react';
import { TradeStatus } from '../ActiveTradesPage';
import { AssetUrls } from 'config/assets';
import './TradeStatusTabs.css';

interface Props {
  activeTab: TradeStatus;
  onTabChange: (tab: TradeStatus) => void;
}

export default function TradeStatusTabs({ activeTab, onTabChange }: Props) {
  const tabs = [
    { 
      key: 'ready' as TradeStatus, 
      label: 'Ready to ship', 
      icon: AssetUrls.icons.misc.sendPackage
    },
    { 
      key: 'transit' as TradeStatus, 
      label: 'In Transit', 
      icon: `${AssetUrls.base}/assets/icons/SendCards/truck-in-transit.svg`
    },
    { 
      key: 'completed' as TradeStatus, 
      label: 'Completed', 
      icon: `${AssetUrls.base}/assets/icons/SendCards/icon-completed.svg`
    }
  ];

  return (
    <div className="trade-status-tabs">
      {tabs.map(tab => (
        <button
          key={tab.key}
          className={`status-tab ${activeTab === tab.key ? 'active' : ''}`}
          onClick={() => onTabChange(tab.key)}
        >
          <img 
            src={tab.icon} 
            alt={tab.label}
            className="tab-icon"
          />
          <span className="tab-label">{tab.label}</span>
        </button>
      ))}
    </div>
  );
}